import { useUnityContext } from 'react-unity-webgl';
import { invokeEvent } from 'shared-base';

export type UnityContextHook = ReturnType<typeof useUnityContext> | null;

export let unityContext: UnityContextHook,
  radius: number = 13,
  modelResolve: PromiseLike<boolean>;

export const setUnityContext = (value: UnityContextHook | null) => {
  if (value === unityContext) {
    return;
  }

  if (unityContext) {
    clearContext(unityContext);
  }

  unityContext = value;
};

export const getUnityContext = () => {
  return unityContext;
};

export const clearContext = (context: UnityContextHook) => {
  try {
  } catch (err) {
    invokeEvent('sentry', { err });
  }
};

export const setRadius = (value: number) => {
  radius = value;
};

export const getRadius = () => {
  return radius;
};

export const setModelResolve = (value: PromiseLike<boolean>) => {
  modelResolve = value;
};

export const modelResolveDone = () => {
  if (modelResolve && typeof modelResolve === 'function') {
    (modelResolve as any)(true);
  }
};
